import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomPaginatorIntl implements MatPaginatorIntl {
	firstPageLabel: string;
	itemsPerPageLabel: string;
	lastPageLabel: string;
	nextPageLabel: string;
	ofLabel: string;
	previousPageLabel: string;

	changes: Subject<void> = new Subject<void>();

	constructor(private translateService: TranslateService) {
		const translateKeys: Array<string> = [
			'PAGINATOR.FIRST_PAGE',
			'PAGINATOR.ITEMS_PER_PAGE',
			'PAGINATOR.LAST_PAGE',
			'PAGINATOR.NEXT_PAGE',
			'PAGINATOR.PREV_PAGE',
			'PAGINATOR.OF_LABEL'
		];
		this.translateService.get(translateKeys).subscribe((trans: { [key: string]: string }) => {
			this.firstPageLabel = trans['PAGINATOR.FIRST_PAGE'];
			this.itemsPerPageLabel = trans['PAGINATOR.ITEMS_PER_PAGE'] + ':';
			this.lastPageLabel = trans['PAGINATOR.LAST_PAGE'];
			this.nextPageLabel = trans['PAGINATOR.NEXT_PAGE'];
			this.previousPageLabel = trans['PAGINATOR.PREV_PAGE'];
			this.ofLabel = trans['PAGINATOR.OF_LABEL'];
		});
	}

	getRangeLabel(page: number, pageSize: number, length: number): string {
		if (length === 0 || pageSize === 0) {
			return `0 ${this.ofLabel} ${length}`;
		}
		length = Math.max(length, 0);
		const startIndex: number = page * pageSize,
			endIndex: number = startIndex < length
				? Math.min(startIndex + pageSize, length)
				: startIndex + pageSize;

		return `${startIndex + 1} - ${endIndex} ${this.ofLabel} ${length}`;
	}
}